//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Optimization.js";
import "../no/Builder.js";
let d=[[[0,"IsShowGraph",1,0],[0,"IsUpdateDisp",1,0],[0,"StudyName",1,0]],[[[],"RunDesignStudy",{},0,0],[["numObjectives"],"GetDesignStudyObjectives",{R_:{objectives:""}},0,0],[["attributeNames","attributeObjects","objectiveTypes","warningLowerLimit","warningUpperLimit","failureLowerLimit","failureUpperLimit"],"SetDesignStudyObjectives",{},7,0],[["numVariables"],"GetDesignStudyVariables",{R_:{variables:""}},0,0],[["attributeNames","attributeObjects","variableTypes","variableLowerLimitValue","variableUpperLimitValue","distributeType","locationParameter","scaleParameter","shapeParameter","valuesCount"],"SetDesignStudyVariables",{},10,0],[[],"BuildAllObjectives",{},0,0],[[],"RemoveAllObjectives",{},0,0],[[],"BuildAllVariables",{},0,0],[[],"RemoveAllVariables",{},0,0]],[]];
SPLM.Optimization.DesignStudyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Optimization.DesignStudyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Optimization.DesignStudyBuilder.DesignStudyObjective = class{
    constructor(attributeName,attributeObject,objectiveType,warningLowerLimit,warningUpperLimit,failureLowerLimit,failureUpperLimit){
        this.attributeName=attributeName;this.attributeObject=attributeObject;this.objectiveType=objectiveType;this.warningLowerLimit=warningLowerLimit;this.warningUpperLimit=warningUpperLimit;this.failureLowerLimit=failureLowerLimit;this.failureUpperLimit=failureUpperLimit;}
    get Attributename(){return this.attributeName}
    set Attributename(val){this.attributeName = val}
    get Attributeobject(){return this.attributeObject}
    set Attributeobject(val){this.attributeObject = val}
    get Objectivetype(){return this.objectiveType}
    set Objectivetype(val){this.objectiveType = val}
    get Warninglowerlimit(){return this.warningLowerLimit}
    set Warninglowerlimit(val){this.warningLowerLimit = val}
    get Warningupperlimit(){return this.warningUpperLimit}
    set Warningupperlimit(val){this.warningUpperLimit = val}
    get Failurelowerlimit(){return this.failureLowerLimit}
    set Failurelowerlimit(val){this.failureLowerLimit = val}
    get Failureupperlimit(){return this.failureUpperLimit}
    set Failureupperlimit(val){this.failureUpperLimit = val}
};

SPLM.Optimization.DesignStudyBuilder.DesignStudyVariable = class{
    constructor(attributeName,attributeObject,variableType,variableLowerLimitValue,variableUpperLimitValue,distributeType,locationParameter,scaleParameter,shapeParameter,valuesCount){
        this.attributeName=attributeName;this.attributeObject=attributeObject;this.variableType=variableType;this.variableLowerLimitValue=variableLowerLimitValue;this.variableUpperLimitValue=variableUpperLimitValue;this.distributeType=distributeType;this.locationParameter=locationParameter;this.scaleParameter=scaleParameter;this.shapeParameter=shapeParameter;this.valuesCount=valuesCount;}
    get Attributename(){return this.attributeName}
    set Attributename(val){this.attributeName = val}
    get Attributeobject(){return this.attributeObject}
    set Attributeobject(val){this.attributeObject = val}
    get Variabletype(){return this.variableType}
    set Variabletype(val){this.variableType = val}
    get Variablelowerlimitvalue(){return this.variableLowerLimitValue}
    set Variablelowerlimitvalue(val){this.variableLowerLimitValue = val}
    get Variableupperlimitvalue(){return this.variableUpperLimitValue}
    set Variableupperlimitvalue(val){this.variableUpperLimitValue = val}
    get Distributetype(){return this.distributeType}
    set Distributetype(val){this.distributeType = val}
    get Locationparameter(){return this.locationParameter}
    set Locationparameter(val){this.locationParameter = val}
    get Scaleparameter(){return this.scaleParameter}
    set Scaleparameter(val){this.scaleParameter = val}
    get Shapeparameter(){return this.shapeParameter}
    set Shapeparameter(val){this.shapeParameter = val}
    get Valuescount(){return this.valuesCount}
    set Valuescount(val){this.valuesCount = val}
};

SPLM.Optimization.DesignStudyBuilder.DesignStudyAttributeType = Object.freeze({
    "Expression" : "Expression", "KFAttribute" : "KFAttribute", "GeometryParameter" : "GeometryParameter"});

SPLM.Optimization.DesignStudyBuilder.DesignStudyConstraintLimitType = Object.freeze({
    "Upper" : "Upper", "Lower" : "Lower"});

SPLM.Optimization.DesignStudyBuilder.DesignStudyDistributeType = Object.freeze({
    "Uniform" : "Uniform", "Normal" : "Normal", "Gamma" : "Gamma"});

export default SPLM;